import type { DocumentFraudScoreDto } from 'korint-sdk';
import { isUnresolvedCategory } from '@folio/utils/document-categories';

export const FRAUD_VERDICT_POLL_INTERVAL_MS = 3_000;
// Covers the upload stream's own check and the first run of the delayed scoring job.
const FRAUD_VERDICT_WINDOW_MS = 5 * 60_000;

/** True while a recently uploaded, classified document still has no fraud verdict. */
export function isAwaitingFraudVerdict({
  documents,
  scores,
  now,
}: {
  documents: ReadonlyArray<{ id: string; category: string | null; createdAt: string }>;
  scores: ReadonlyArray<Pick<DocumentFraudScoreDto, 'documentId'>>;
  now: number;
}): boolean {
  const scoredDocumentIds = new Set(scores.map(({ documentId }) => documentId));
  return documents.some(
    ({ id, category, createdAt }) =>
      !scoredDocumentIds.has(id) &&
      !isUnresolvedCategory(category) &&
      now - new Date(createdAt).getTime() < FRAUD_VERDICT_WINDOW_MS,
  );
}
